// extracted by mini-css-extract-plugin
module.exports = {"Screen":"Screen__XRIIP","prev":"prev__1BK7z","next":"next__ivQGF","current":"current__3k6-7","isHidden":"isHidden__1NLXx"};